import React from "react";

const Booking = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        S.
        <span className="text-[#01A7D1] "> Remote Booking Terms -</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        In case you are unable to visit a Yostel property immediately, then you
        can opt for a remote booking option. However this remote booking option
        is currently available only in select Yostel properties.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Below are the steps for remote booking:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 1: You share your details on the website
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 2: A dedicated sales expert will reach out and help you select the
        ideal property for you
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 3: You'll confirm the booking and receive a link to download the
        Yostel - Resident App in order to pay the token amount
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 4: Once token amount is paid, you visit the property at a
        convenient time and our team member will show you all the rooms
        available as per your finalised category
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 5: Select a room in the same budget or you can choose to upgrade as
        well (subject to availability)
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Step 6: Make payment of the balance amount
      </p>
    </div>
  );
};

export default Booking;
